// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PostComments-cls1___c24397134726711ee8e{/*!*/}.PostComments-cls2___a076b1395588a7a3ed0{display:none}.PostComments-cls2___a076b1395588a7a3ed0.PostComments-show__f57fa7e9e07cee48a050{display:block}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PostComments-cls1___c24397134726711ee8e",
	"cls2": "PostComments-cls2___a076b1395588a7a3ed0 PostComments-cls1___c24397134726711ee8e",
	"show": "PostComments-show__f57fa7e9e07cee48a050"
};
export default ___CSS_LOADER_EXPORT___;
